// Framework and third-party non-UI
import React from 'react';

// Redux, contexts, and local helpers/utils/modules

// Component specific modules (Component-styled, etc.)

// App components

// Third-party components (buttons, icons, etc.)
import { CalciteOption } from '@esri/calcite-components-react';

export interface CalciteOptionWrapperProps
  extends Omit<React.ComponentProps<typeof CalciteOption>, 'value'> {
  value: string | number | boolean | null;
}

const CalciteOptionWrapper = ({
  disabled,
  selected,
  value,
  ...rest
}: CalciteOptionWrapperProps) => {
  return (
    <CalciteOption
      disabled={disabled || undefined}
      selected={selected || undefined}
      value={typeof value === 'number' ? String(value) : value}
      {...rest}
    />
  );
};

export default CalciteOptionWrapper;
